export function milliToTime(milli: number) {
  const zeroPad = (num: number, places: number) =>
    String(num).padStart(places, "0")

  const minutes = Math.floor(milli / 60000)
  const seconds = zeroPad(Math.floor((milli - minutes * 60000) / 1000), 2)
  const milliSeconds = zeroPad(milli % 1000, 3)

  return `${minutes}'${seconds}"${milliSeconds}`
}